import React from "react";
import classNames from './style.module.scss';

interface ColorPreviewProps {
    colors: string[];
}

const ColorPreview: React.FC<ColorPreviewProps> = ({ colors }) => {
    return ( 
        <div className={classNames.colorPreview}>
            {colors.map((color) => (
                <div key={color} className={classNames.colorPreviewItem} style={{ backgroundColor: color }} />
            ))}
        </div>
     );
}
 
export default ColorPreview;